import React from 'react';
const ImageLoad = React.memo((props) => {
    var _a;
    const loadDoneHandler = () => {
        props.setStatus(props.imgSrc, true);
    };
    return (React.createElement("img", { style: Object.assign({}, props.style), className: (_a = props.classes) === null || _a === void 0 ? void 0 : _a.join(' '), src: props.imgSrc, onLoad: loadDoneHandler }));
});
export default ImageLoad;
